import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=b41d88a6&scoped=true&"
import script from "./UploadComponent.vue?vue&type=script&lang=ts&"
export * from "./UploadComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UploadComponent.vue?vue&type=style&index=0&id=b41d88a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41d88a6",
  null
  
)

export default component.exports